import React from "react";
import { Field, reduxForm, stopSubmit } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../../system/fields/TextInput";
import SelectDropdown from "../../../system/fields/SelectDropdown";
import FileUpload from "../../../system/fields/FileUpload";
import StarRating from "../../../system/fields/StarRating";

import * as validations from "../../../system/utils/Validation";
import DatePickerOld from "../../../system/fields/DatePickerOld";

let EditForm = (props, { fields }) => {
  const { handleSubmit, mode } = props;
  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit}>
        <section className="form-section">
          <div className="form-section-header">Personal Details</div>

          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">First Name</Label>
              <Field
                name="first_name"
                component={TextInput}
                placeholder="First Name"
                type="text"
                validate={validations.required}
                disabled
              />
            </FormGroup>

            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Last Name</Label>
              <Field
                name="last_name"
                placeholder="Last Name"
                component={TextInput}
                type="text"
                validate={validations.required}
                disabled
              />
            </FormGroup>
          </div>

          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Email Address</Label>
              <Field
                name="email"
                component={TextInput}
                type="email"
                validate={[validations.required, validations.email]}
                disabled
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Phone Number</Label>
              <Field
                name="phone_number"
                component={TextInput}
                type="phone"
                validate={[validations.required, validations.phoneNumber]}
                disabled
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Destinations</Label>
              <Field
                name="destinations"
                component={SelectDropdown}
                options={props.destinations}
                valueKey="id"
                labelKey="name"
                multi={true}
                className="form-control"
                disabled
              />
            </FormGroup>

            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Min Price (per person)</Label>
              <Field
                name="price_range.min"
                component={TextInput}
                type="number"
                validate={[validations.required]}
                disabled
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Max Price (per person)</Label>
              <Field
                name="price_range.max"
                component={TextInput}
                type="number"
                validate={[validations.required]}
                disabled
              />
            </FormGroup>
            <FormGroup className={"col-12 col-sm-6"}>
              <Label>Departure Airport</Label>
              <Field
                name={"departure_airport"}
                component={SelectDropdown}
                multi
                labelKey={"name"}
                valueKey={"id"}
                type={"text"}
                disabled
              />
            </FormGroup>
            <FormGroup className={"col-12 col-sm-6"}>
              <Label>Nights</Label>
              <Field
                name={"nights"}
                component={TextInput}
                type={"number"}
                disabled
              />
            </FormGroup>
            <FormGroup className={"col-12 col-sm-6"}>
              <Label>Travellers</Label>
              <Field
                name={"travellers"}
                component={TextInput}
                type={"number"}
                disabled
              />
            </FormGroup>
            <FormGroup className={"col-12 col-sm-6"}>
              <Label>Start Date</Label>
              <Field
                name={"start_date.date"}
                dateFormat={"MMM dd yyyy h:mm a"}
                component={DatePickerOld}
                disabled
              />
            </FormGroup>
            <FormGroup className={"col-12 col-sm-6"}>
              <Label>End Date</Label>
              <Field
                name={"end_date.date"}
                dateFormat={"MMM dd yyyy h:mm a"}
                component={DatePickerOld}
                disabled
              />
            </FormGroup>
            <FormGroup className={"col-12 col-sm-6"}>
              <Label>How Did You Hear About Us?</Label>
              <Field
                name={"hduhau"}
                component={TextInput}
                type={"text"}
                disabled
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Referrer</Label>
              <Field name="ref" component={TextInput} type="text" disabled />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">GCLID</Label>
              <Field name="gclid" component={TextInput} type="text" disabled />
            </FormGroup>
          </div>
        </section>
      </Form>

      {props.submitFailed && (
        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />
            Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: "HolidayEnquriyForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit("TestForm"));
    }
  },
})(EditForm);

export default EditForm;



// WEBPACK FOOTER //
// ./src/containers/Enquiries/HolidayEnquiry/Form.jsx